import reportAlertIcon from '../../../assets/reportAlertIcon.png';

export default function CurriPrivateSnackbarIcon() {
  return (
    <img src={reportAlertIcon} alt="" />
  );
}